import { defineStore } from 'pinia'
import { ref } from 'vue'

const defaultBrand = () => {
  return {
    autoplay: true,
    bigPlayButton: '#FFFFFF',
    bigPlayButtonBack: '#3275a8',
    bigPlayButtonHeight: 2,
    bigPlayButtonRadius: 50,
    bigPlayButtonSize: 4,
    control: '#CCCCCC',
    controlBar: '#040E15',
    controlSize: 1,
    customStyle: '',
    isDefault: true,
    loadingSpinner: '#FFFFFF',
    loadProgress: '#585858',
    muted: true,
    name: 'My template',
    playlist: true,
    playProgress: '#3275a8',
    progressHolder: '#2E2E2E',
    related: true,
    saveCurPos: true,
    social: true,
    speedChange: true,
    switcher: true,
    vastAdTagUrl: '',
    videojsVer: '7',
    volumeBar: '#2E2E2E',
    volumeLevel: '#3275a8',
    watermark: {
      link: '',
      yPos: 0,
      xPos: 0,
      height: '50',
      controlBarLogo: '',
      controlBarLogoHref: ''
    }
  }
}

export const useBrandsStore = defineStore('brandsStore', {
  state: () => {
    const brands = []
    const brand = ref(defaultBrand())
    const mode = ref(0) // 0 = list, 1 = editor

    const toggleMode = () => {
      mode.value = mode.value > 0 ? 0 : 1
    }

    const setDefault = () => {
      brand.value = defaultBrand()
    }

    return {
      brand,
      brands,
      mode,
      toggleMode,
      setDefault
    }
  }
})
